window.VegasCompare = {
	add: function ($self) {
		let $product = $self.closest('[data-cart=product]');
		let id = $self.data('id') || $product.data('id');

		$self.attr('title', $self.data('title-active'));
		$self.attr('data-compare', 'del');
		$self.blur();

		let params = {
			_token: App.csrf,
			product_id: id
		};

		$.post('/compare/add_product', params, function (data) {
			VegasCompare.updateCounter(data);
			$product.addClass('in-compare');

			VegasCompare.popup($product.data('title'), true);
		});
	},
	del: function ($self) {
		let $product = $self.closest('[data-cart=product]');
		let id = $self.data('id') || $product.data('id');

		$self.attr('title', $self.data('title-active'));
		$self.attr('data-compare', 'del');
		$self.blur();

		this.delRequest(id, function (data) {
			$product.removeClass('in-compare');
			VegasCompare.updateCounter(data);
		});
	},

	delRequest: function (id, callback) {
		let params = {
			_token: App.csrf,
			product_id: id
		};

		$.post('/compare/del_product', params, function (data) {
			if (typeof callback == 'function') {
				callback(data);
			}
		});
	},

	updateCounter: function (data) {
		if (typeof data.cnt !== false) {
			$('[data-counter=compare]').attr('data-cnt', data.cnt);
		}
	},

	remove: function ($self) {
		let $product = $self.closest('[data-cart=product]');

		VegasCompare.delRequest(id, function () {
			$('.owl-compare').owlCarousel().trigger('remove.owl.carousel', [owlIndex]);
			$('.owl-compare-option').owlCarousel().trigger('remove.owl.carousel', [owlIndex]);

			$('.owl-compare [data-owl-index]').each(function (i, e) {
				$(e).attr('data-owl-index', i);
			});
			$('.owl-compare-option [data-owl-index]').each(function (i, e) {
				$(e).attr('data-owl-index', i);
			});

			if (($products.length - 1) === 0) {
				location.reload();
			}
		});
	},

	removeOwl: function ($self) {
		let $product = $self.closest('[data-compare=product]'),
			$products = $('[data-compare=product]'),
			owlIndex = $product.data('owl-index'),
			id = $product.data('id')
		;

		VegasCompare.delRequest(id, function () {
			$('.owl-compare').owlCarousel().trigger('remove.owl.carousel', [owlIndex]);
			$('.owl-compare-option').owlCarousel().trigger('remove.owl.carousel', [owlIndex]);

			$('.owl-compare [data-owl-index]').each(function (i, e) {
				$(e).attr('data-owl-index', i);
			});
			$('.owl-compare-option [data-owl-index]').each(function (i, e) {
				$(e).attr('data-owl-index', i);
			});

			if (($products.length - 1) === 0) {
				location.reload();
			}
		});
	},

	popup: function (title, status = false) {
		let $modal = $('#modal-add-success');

		$modal.find('h4').text('Товар "' + title + '" добавлен к сравнению');

		$modal.modal('show');

		setTimeout(() => {
			$modal.modal('hide')
		}, 1500);
	},

	filter: function (val) {
		$containerOptions = $('.compare-option-holder');

		if (val === 'all') {
			$containerOptions.find('.compare-option').show();
		} else if (val === 'different' || val === 'similar') {
			$containerOptions.find('.compare-option').each(function () {
				let values = $(this).find('.product-option').map(function () {
					return $.trim($(this).text());
				}).toArray();

				let valuesUnique = Array.from(new Set(values));

				if (val === 'different') {
					if (valuesUnique.length > 1) {
						$(this).show();
					} else {
						$(this).hide();
					}
				} else if (val === 'similar') {
					if (valuesUnique.length === 1) {
						$(this).show();
					} else {
						$(this).hide();
					}
				}
			});
		}
	}
};

let $window = $(window),
	$body = $('body'),
	$document = $(document)
;

$document.on('click', '[data-compare=add]', function () {
	VegasCompare.add($(this));
	return false;
});
$document.on('click', '.vg-shop-card [data-compare=del], .vg-shop-prd [data-compare=del]', function () {
	VegasCompare.del($(this));
	return false;
});

$document.on('click', '.compare-card [data-compare=del]', function () {
	VegasCompare.removeOwl($(this));
	return false;
});

$(document).on('change', '.compare-radio-group [name=compare]', function () {
	VegasCompare.filter($(this).val());
});